import TokenData from './contracts/Token.json'; // Kita cuma butuh 1 file ABI ini

// Alamat Kontrak Utama (Sudah benar)
export const TOKEN_ADDRESS = '0x529eb0D5c55914D548aAD940d16743c37aB300FD';

// Kita tidak butuh AIRDROP_ADDRESS terpisah, sama dengan TOKEN_ADDRESS
export const AIRDROP_ADDRESS = TOKEN_ADDRESS; 

export const RPC_URL = 'https://rpc.ankr.com/bsc/9eac904ebaa1333306011e829641a4c8f0da94785c711097ba7de2b744ccbce0';

// ABI yang digunakan adalah ABI dari ForUAI (sudah mencakup claim, swap, transfer, dll)
export const TOKEN_ABI = TokenData.abi as any;
export const AIRDROP_ABI = TOKEN_ABI; // Gunakan ABI yang sama

export const CHAIN_ID = 56;

export const CLAIM_FEE_BNB = 0.005;
export const SWAP_FEE_BNB = 0.01487;